import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import indexRoutes from "./routes";
import { ThemeProvider } from "@material-ui/styles";
import { theme } from "./utils/muiTheme";
import { Provider } from "react-redux";
import AuthErrorHandler from "./components/Shared/AuthErrorHandler/AuthErrorHandler";
import SmartLoader from "./components/Shared/Loader/SmartLoader";
import Header from "./components/Shared/Header";
import Footer from "./components/Shared/Footer";
import store from "./store/configureStore";
import "./App.css";

// Google Analytics module
import ReactGA from "react-ga";

// initialize react-ga module
ReactGA.initialize("UA-172736709-1");
ReactGA.pageview("/");

const mainStyle = {
  minHeight: "100vh",
  backgroundColor: "white"
};

function App() {
  return (
    <div style={mainStyle}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <Router>
            {/*
              Must stay in step with `oauth.client_id` in BartAPI's
              src/config/secrets.json. The auth-code flow has the browser obtain
              a code for this client and BartAPI redeem it as that one, so if the
              two drift apart Google rejects the exchange with
              `unauthorized_client` and sign-in fails with no other clue.
            */}
            <GoogleOAuthProvider clientId="425569977075-6t5j0lt84qd1th2a346bcqil39u3280s.apps.googleusercontent.com">
              <AuthErrorHandler>
                <SmartLoader>
                  <Header />
                  <Switch>
                    {indexRoutes.map((route, key) => {
                      return (
                        <Route
                        path={route.path}
                        key={key}
                        component={route.component}
                        />
                      );
                    })}
                  </Switch>
                  <Footer />
                </SmartLoader>
              </AuthErrorHandler>
            </GoogleOAuthProvider>
          </Router>
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default App;
